import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { gmatApi } from '@/lib/gmatApi';
import { toast } from 'sonner';

const ALLOWED_NEXT = new Set(['/gmat', '/gmat/dashboard', '/gmat/practice', '/gmat/mock-test']);

const resolveNext = (queryNext) => {
  let next = queryNext;
  if (!next) {
    try { next = sessionStorage.getItem('gmat_post_login_next') || ''; } catch (e) { next = ''; }
  }
  if (next && ALLOWED_NEXT.has(next)) return next;
  return '/gmat/dashboard';
};

/** Catches the #session_id={...} fragment after Emergent Google Auth redirect. */
const GmatProfilePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const dest = resolveNext(searchParams.get('next'));
    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      gmatApi.authMe()
        .then(() => {
          try { sessionStorage.removeItem('gmat_post_login_next'); } catch (e) { /* ignore */ }
          navigate(dest);
        })
        .catch(() => navigate('/gmat'));
      return;
    }
    const sid = decodeURIComponent(m[1]);
    gmatApi.authExchange(sid)
      .then(() => {
        window.history.replaceState(null, '', dest);
        try { sessionStorage.removeItem('gmat_post_login_next'); } catch (e) { /* ignore */ }
        toast.success('Signed in. Welcome.');
        navigate(dest);
      })
      .catch((e) => {
        console.error(e);
        setError(e.message || 'Auth failed');
      });
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      {error ? (
        <div className="text-center">
          <p className="text-red-600 mb-3" data-testid="gmat-auth-error">{error}</p>
          <button onClick={() => navigate('/gmat')} className="underline">Back to GMAT home</button>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-gray-600">
          <Loader2 className="h-5 w-5 animate-spin" /> Signing you in…
        </div>
      )}
    </div>
  );
};
export default GmatProfilePage;
